import _implicitStylesheets from "./emptySpace.css";
import _implicitScopedStylesheets from "./emptySpace.scoped.css?scoped=true";
import _i18nLink from "i18n/link";
import _c360Button from "c360/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="slds-align_absolute-center slds-m-top_x-large slds-m-bottom_x-large${0}"${2}><img${"a1:src"} class="illustration${0}"${"a1:alt"} width="auto" height="238px"${2}></div>`;
const stc0 = {
  classMap: {
    "slds-align_absolute-center": true,
    "title": true,
    "slds-m-bottom_medium": true
  },
  key: 2
};
const stc1 = {
  classMap: {
    "slds-align_absolute-center": true,
    "description": true,
    "slds-m-bottom_medium": true
  },
  key: 4
};
const stc2 = {
  "slds-align_absolute-center": true
};
const stc3 = {
  "data-test-id": "empty-space-action"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [api_static_fragment($fragment1, 1, [api_static_part(1, {
    attrs: {
      "src": $cmp.image,
      "alt": $cmp.imageAlt
    }
  }, null)]), api_element("span", stc0, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.label
    },
    key: 3
  })]), api_element("span", stc1, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.descriptionLabel
    },
    key: 5
  })]), $cmp.buttonLabel ? api_custom_element("c360-button", _c360Button, {
    classMap: stc2,
    attrs: stc3,
    props: {
      "label": $cmp.buttonLabel,
      "variant": "brand"
    },
    key: 6,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.buttonAction))
    }
  }) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-701fs275hn3";
tmpl.legacyStylesheetToken = "appx-emptySpace_emptySpace";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
